












import Vue from "vue";
import FormDialog, { iFormDialogOptions } from "@/components/FormDialog.vue";
import { mapActions, mapMutations } from "vuex";

import Topic from "@/views/full/pages/news/Topic.vue";
import Post from "@/views/full/pages/news/Post.vue";
export default Vue.extend({
  name: "news",
  components: {
    Topic,
    Post
  },
  data() {
    return {
      selectedTopics: [],
      topics: null
    };
  },
  methods: {
    ...mapActions({ checkShowMenu: "menu/checkShowMenu" }),
    topicSelected(event) {
      this.selectedTopics = null;
      setTimeout(() => {
        if (event) this.selectedTopics = event;
        else this.selectedTopics = [];
      });
    }
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
  }
});
